/* eslint-disable react/prop-types */

import React from 'react';

import {connect} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import {initUpdateActiveMenu} from '@/businesses/autoProfileBusiness';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';

import AutoProfilePageMenu from '../reusable/AutoProfilePageMenu';
import AutoProfileTopMenu from '../reusable/AutoProfileTopMenu';
import ManualControlPopup from '../reusable/ManualControlPopup';
import StatusDiagram from '../reusable/StatusDiagram';
import StatusProfile from '../reusable/StatusProfile';
// eslint-disable-next-line import/no-cycle
import StatusSensor from '../reusable/StatusSensor';

import './AutoProfileStatus.less';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
}))
class AutoProfileStatus extends React.PureComponent {
  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(initUpdateActiveMenu(APPDATA.AUTO_PROFILE_STATUS_TAB));
  }

  componentWillUnmount() {
    const {dispatch} = this.props;
    dispatch(setupActions.topButtonSecondaryProperties(undefined));
  }

  render() {
    const {fontSize} = this.props;
    const style = {
      constraint: {
        fontSize: fontSize === APPDATA.LARGE_FONT_SIZE ? APPDATA.MEDIUM_FONT_SIZE : fontSize,
      },
    };

    return (
      <div style={style.constraint}>
        <div className="row AutoProfilStatusRow auto-profile-status">
          <div className={`${APPSTYLE.COLUMN_9}col-statusBox no-padding`}>
            <div className={`${APPSTYLE.COLUMN_9}statusBox no-padding`}>
              {/* <div className="statusText"> */}
              <StatusSensor />
              {/* </div> */}
            </div>

            <div className={`${APPSTYLE.COLUMN_FULL}NewProfileBox no-padding`}>
              <div className="profileText">
                <StatusProfile />
              </div>
            </div>
          </div>
          <div
            className={`${APPSTYLE.COLUMN_3}col-canvas center`}
            style={{paddingLeft: '16px'}}
          >
            <StatusDiagram />
          </div>
        </div>
        <AutoProfileTopMenu
          activeTopMenu={APPDATA.AUTO_PROFILE_STATUS_TAB}
          titleTopMenu={APPDATA.AUTO_PROFILE.toUpperCase()}
        />
        <AutoProfilePageMenu />
        <ManualControlPopup />
      </div>
    );
  }
}

export default AutoProfileStatus;
